import propal from "@/ds/vendor/assets/characters/Propal.svg";
import happyPropal from "@/ds/vendor/assets/characters/Happy Propal.svg";
import bukkie from "@/ds/vendor/assets/characters/Bukkie.svg";
import car from "@/ds/vendor/assets/characters/Car.svg";
import cow from "@/ds/vendor/assets/characters/Cow 1.svg";
import chicken from "@/ds/vendor/assets/characters/Chicken.svg";
import farmer from "@/ds/vendor/assets/characters/Farmer.svg";

// "Propal & friends" (assets/characters): empty states, onboarding and small
// celebratory moments only. Plain title + one declarative line, never a joke.
const ART = { propal, "happy-propal": happyPropal, bukkie, car, cow, chicken, farmer } as const;
export type CharacterName = keyof typeof ART;

export function Character({ name, size = 96, title, line, action }: { name: CharacterName; size?: number; title?: string; line?: string; action?: React.ReactNode }) {
  return (
    <div className="character">
      <img src={ART[name]} alt="" aria-hidden="true" style={{ height: size }} className={`character-art character-art--${name}`} />
      {title && <div className="character-title">{title}</div>}
      {line && <div className="character-line">{line}</div>}
      {action}
    </div>
  );
}
